import axios from '../../../libs/axios_csrf';
import moment from 'moment';
import {extendObservable, computed, action} from 'mobx';
import {injectIntl} from 'react-intl';
import BlockStore from './BlockStore';
import { debug } from 'util';

export default class SuggestStore {
	constructor(rootStore) {
		this.rootStore = rootStore;
		extendObservable(this, {
			mvps: {},
			loadedData: true,
		})	
		axios.get(`/bmc_boards/mvps_ids`).then(
            (response) => {
				this.mvps = response.data;
			}).catch((e) => console.log("error", e))
		}

	@action 
	setLoadedData(atr) {
		this.loadedData = atr;
	}

	@action
	loadMvpBmc(mvp) {
		this.loadedData = false;
		if (this.mvps.hasOwnProperty(mvp)) {
			axios.get(`/bmc_boards/bmc_blocks/${this.mvps[mvp].id}`, {}).then(
				(response) => {
					response.data.forEach((block) => {
						const _block = new BlockStore(this.rootStore, block);
						this.mvps[mvp] = {
							...this.mvps[mvp],
							blocks: {...this.mvps[mvp].blocks,
								[_block.name]: _block  },
						}
					});
					this.loadedData = true;
				}).catch((e) => console.log("error", e))
		}
	}

	getCardsByBlock(mvp, blockName) {
		if( this.mvps[mvp] && this.mvps[mvp].blocks && this.mvps[mvp].blocks[blockName]) {
			return this.mvps[mvp].blocks[blockName].cards;
		}
		return [];
	}
}